import React from 'react';
import Main from './Main';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout = () => {
  return (
    <div className='layout-container' >
      <Sidebar/>
      <Header/>
      <Main/>
    </div>
  );
};

export default MainLayout;